/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentScheduleBulkUpsert } from '../models/PaymentScheduleBulkUpsert';
import type { PaymentScheduleCreate } from '../models/PaymentScheduleCreate';
import type { PaymentScheduleResponse } from '../models/PaymentScheduleResponse';
import type { PaymentScheduleUpdate } from '../models/PaymentScheduleUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoicePaymentScheduleService {
    /**
     * List Payment Schedules
     * @returns PaymentScheduleResponse Successful Response
     * @throws ApiError
     */
    public static listPaymentSchedulesInvoicesPaymentSchedulesGet(): CancelablePromise<Array<PaymentScheduleResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/payment-schedules/',
        });
    }
    /**
     * Create Payment Schedule
     * @param requestBody
     * @returns PaymentScheduleResponse Successful Response
     * @throws ApiError
     */
    public static createPaymentScheduleInvoicesPaymentSchedulesPost(
        requestBody: PaymentScheduleCreate,
    ): CancelablePromise<PaymentScheduleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/payment-schedules/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payment Schedule
     * @param id
     * @returns PaymentScheduleResponse Successful Response
     * @throws ApiError
     */
    public static getPaymentScheduleInvoicesPaymentSchedulesIdGet(
        id: number,
    ): CancelablePromise<PaymentScheduleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/payment-schedules/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Payment Schedule
     * @param id
     * @param requestBody
     * @returns PaymentScheduleResponse Successful Response
     * @throws ApiError
     */
    public static updatePaymentScheduleInvoicesPaymentSchedulesIdPut(
        id: number,
        requestBody: PaymentScheduleUpdate,
    ): CancelablePromise<PaymentScheduleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoices/payment-schedules/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Payment Schedule
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deletePaymentScheduleInvoicesPaymentSchedulesIdDelete(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/invoices/payment-schedules/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Upsert Payment Schedules
     * @param invoiceId
     * @param requestBody
     * @returns PaymentScheduleResponse Successful Response
     * @throws ApiError
     */
    public static bulkUpsertPaymentSchedulesInvoicesPaymentSchedulesInvoicesInvoiceIdPaymentSchedulesPut(
        invoiceId: number,
        requestBody: PaymentScheduleBulkUpsert,
    ): CancelablePromise<Array<PaymentScheduleResponse>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoices/payment-schedules/invoices/{invoice_id}/payment-schedules',
            path: {
                'invoice_id': invoiceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
